const chat_server_url = 'https://chat.pilgway.com/';
//const chat_server_url = 'http://127.0.0.1:8000/';
const get_answer_json_url = 'get_answer_json/';
const set_reaction_json_url = 'set_reaction_json/';

var context_qa_arr = [];

function sendJSON(url, jsonData, callback) {
    // Convert the JSON object to a string
    const data = JSON.stringify(jsonData);

    console.log('jsonData:', jsonData);
    console.log('question:', jsonData.question);

    // Create a new XMLHttpRequest object
    const xhr = new XMLHttpRequest();

    // Set the HTTP method and URL
    xhr.open('POST', url, true);

    // Set the request headers
    xhr.setRequestHeader('Content-Type', 'application/json');

    // Set up a callback function to handle the response
    xhr.onload = function () {
        if (xhr.status === 200) {
            //console.log('JSON sent successfully');
            // Do something with the response if needed
            const response = JSON.parse(xhr.responseText);
            console.log('Server response:', response);

            //hideLoading(); // Hide the loading animation
            callback(response);
        } else {
            console.error('Error sending JSON:', xhr.status);
        }
    };

    // Send the request
    xhr.send(data);
}


function handleText(question, user_id, model_name) {
    console.log('Entered text:', question);
    showLoading(); // Show the loading animation
    var currentURL = window.location.href;

    var prompt_qa_content_element = document.getElementById('prompt-qa-content');
    if (prompt_qa_content_element) {
        var prompt_qa_content_body = document.getElementById('prompt-qa-content-body');
        var parent = prompt_qa_content_element.parentNode;
        parent.style.height = 'auto';
        removeAllChildElements(prompt_qa_content_body);
    }

    if (typeof licenses_prompt !== "undefined") {
        if (isCheckboxChecked('addLicenseInfo')) {
            question = licenses_prompt + ' ' + question;

            if (typeof program_version_prompt !== "undefined") {
                if(program_version_prompt){
                    question = program_version_prompt + ' ' + question;
                }
            }
        }
    }


    var jsonData = {
        action: 'get_answer_main',
        question: question,
        model_name: model_name,
        mode: 'production',
        user_id: user_id,
        source: currentURL,
        context_qa: context_qa_arr,
    };

    sendJSON(chat_server_url+get_answer_json_url, jsonData, addChatAnswer);
}

function sendText(textArea, callback) {

    console.log('loadingStartTime', loadingStartTime);

    if(loadingStartTime === false) {
        const text = textArea.value.trim();
        const user_id = textArea.getAttribute('data-userid');

        if (text !== '') {
            callback(text, user_id, open_ai_model_name);
        }
        addUserReply('conversation', text);
        scrollChatConversationToBottom();
        textArea.value = '';
    }
}



function addChatAnswer(response){
    hideLoading(); // Hide the loading animation

    var icons = document.getElementById('icons-thumbs');
    if(icons){
        icons.setAttribute('data-userquestionid', response.user_question_id);
        icons.style.display = "block";

    }

    var checkbox = document.getElementById('addLicenseInfo');
    if (checkbox) {
        checkbox.checked = false;
    }
    addAIReply('conversation', response.answer, response.user_question_id);
    scrollChatConversationToBottom();

    var prompt_qa_content_element = document.getElementById('prompt-qa-content');
    if (prompt_qa_content_element) {
        var parent = prompt_qa_content_element.parentNode;
        parent.style.display = "block";
        parent.style.height = '80vh';

    }

    var prompt_qa_content_body = document.getElementById('prompt-qa-content-body');
    if (prompt_qa_content_body) {
        addPromptQuestionsAnswers(prompt_qa_content_body, response.q_a_pairs);
    }
    context_qa_arr.push({'question': response.question, 'answer': response.answer});
    console.log(context_qa_arr);
}



function addPromptQuestionsAnswers(prompt_qa_content_element, prompt_q_a_pairs){
    addChildElement(prompt_qa_content_element, 'h3', 'Q&A from our knowledge base')

    for (var i = 0; i < prompt_q_a_pairs.length; i++) {
        let q_a_pair = prompt_q_a_pairs[i];
        let question = capitalizeFirstLetter(q_a_pair.question);
        let num = i + 1;
        question = num + '. ' + question;
        let answer = q_a_pair.answer;

        // answer = replaceUrlsWithLinks(answer);
        // answer = replaceNewlinesWithBreaks(answer);
        // answer = formatCodeBlocks(answer);

        answer = marked.parse(answer);

        addPromptQuestionAnswer(prompt_qa_content_element, question, answer);
    }
}

function addChildElement(parentElement, elementName, elementContentHtml){
    const element = document.createElement(elementName);
    element.innerHTML = elementContentHtml;
    parentElement.appendChild(element);
}

function removeAllChildElements(parentElement) {
    while (parentElement.firstChild) {
        parentElement.removeChild(parentElement.firstChild);
    }
}

function addPromptQuestionAnswer(prompt_qa_content_element, question, answer){
    const question_answer = document.createElement('div');
    addChildParagraph(question_answer, '<b>'+question+'</b>');
    addChildParagraph(question_answer, answer);
    prompt_qa_content_element.appendChild(question_answer);
}

function addChildParagraph(parentElement, html) {
    const paragraph = document.createElement('p');
    //const paragraphText = document.createTextNode(text);
    paragraph.innerHTML = html;
    //paragraph.appendChild(paragraphText);
    parentElement.appendChild(paragraph);
}

function scrollChatConversationToBottom() {
    const scrollContainer = document.querySelector('.conversation');
    scrollContainer.scrollTop = scrollContainer.scrollHeight;
}

function replaceUrlsWithLinks(text) {
    var urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    return text.replace(urlPattern, function(url) {
        url = url.replace(/\.$/, '');
        if (url.startsWith("http://") || url.startsWith("https://")) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>';
        } else {
            return '<a href="http://' + url + '" target="_blank">' + url + '</a>';
        }
    });
}

function replaceNewlinesWithBreaks(text) {
    return text.replace(/\n/g, '<br>');
}

function formatCodeBlocks(text) {
    // Define a regular expression pattern to match code blocks
    var codeBlockPattern = /```(\w+)?([\s\S]*?)```/g;

    // Replace each matched code block with <pre> tags
    var formattedText = text.replace(codeBlockPattern, function (match, lang, code) {
        if (lang) {
            lang = lang.toLowerCase(); // Convert the language to lowercase
        }
        code = code.trim(); // Remove leading and trailing whitespace
        var preTag = '<pre';
        if (lang) {
            preTag += ' class="' + lang + '"';
        }
        preTag += '><code>' + code + '</code></pre>';
        return preTag;
    });

    return formattedText;
}

function addAIReply(parentId, text, user_question_id){
    const parentDiv = document.getElementById(parentId);

    // text = replaceUrlsWithLinks(text);
    // text = replaceNewlinesWithBreaks(text);
    // text = formatCodeBlocks(text);

    text = marked.parse(text);

    if (parentDiv) {
        const newDiv = document.createElement("div");
        newDiv.className = "reply ai";
        newDiv.innerHTML =  '<span class="name"><div class="name-text">AI:</div></span>';

        const newSpan = document.createElement("span");
        newSpan.className = "text";
        newSpan.innerHTML =  '<div class="text-content"> ' + text + '</div>\n';

        const reactionButtonsElement = getReactionButtonsElement(user_question_id)
        newSpan.appendChild(reactionButtonsElement);
        newDiv.appendChild(newSpan);


        parentDiv.appendChild(newDiv);

        return newDiv;
    }
    return null;
}

function getReactionButtonsElement(user_question_id){
    const newDiv = document.createElement("div");
    newDiv.className = "icons";
    newDiv.setAttribute('data-userquestionid', user_question_id);

    let like_icon = createReactionButton('Like', user_question_id, 'Good response')
    newDiv.appendChild(like_icon);

    let dislike_icon = createReactionButton('Dislike', user_question_id, 'Bad response')
    newDiv.appendChild(dislike_icon);

    return newDiv;
}

function createReactionButton(reaction_type, user_question_id, title){
    const width = "18";
    const height = "18";
    const newDiv = document.createElement("div");
    newDiv.className = "icon-container";
    let svg = createSVGElement(width, height, reaction_type);
    addReactionEventListener(svg, reaction_type, user_question_id);
    newDiv.appendChild(svg);

    const newSpan = document.createElement("span");
    newSpan.className = "tooltip";
    newSpan.innerHTML = title;
    newDiv.appendChild(newSpan);

    return newDiv;
}

function createSVGElement(width, height, reaction_type){
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", width);
    svg.setAttribute("height", height);
    svg.setAttribute("fill", "currentColor");

    svg.setAttribute("viewBox", "0 0 16 16");
    if(reaction_type === 'Like'){
        svg.setAttribute("class", "bi bi-hand-thumbs-up");
        svg.setAttribute("title", "Good response");
        svg.innerHTML = '<path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"/>';
    }
    if(reaction_type === 'Dislike'){
        svg.setAttribute("class", "bi bi-hand-thumbs-down");
        svg.setAttribute("title", "Bad response");
        svg.innerHTML = '<path d="M8.864 15.674c-.956.24-1.843-.484-1.908-1.42-.072-1.05-.23-2.015-.428-2.59-.125-.36-.479-1.012-1.04-1.638-.557-.624-1.282-1.179-2.131-1.41C2.685 8.432 2 7.85 2 7V3c0-.845.682-1.464 1.448-1.546 1.07-.113 1.564-.415 2.068-.723l.048-.029c.272-.166.578-.349.97-.484C6.931.08 7.395 0 8 0h3.5c.937 0 1.599.478 1.934 1.064.164.287.254.607.254.913 0 .152-.023.312-.077.464.201.262.38.577.488.9.11.33.172.762.004 1.15.069.13.12.268.159.403.077.27.113.567.113.856s-.036.586-.113.856c-.035.12-.08.244-.138.363.394.571.418 1.2.234 1.733-.206.592-.682 1.1-1.2 1.272-.847.283-1.803.276-2.516.211a10 10 0 0 1-.443-.05 9.36 9.36 0 0 1-.062 4.51c-.138.508-.55.848-1.012.964zM11.5 1H8c-.51 0-.863.068-1.14.163-.281.097-.506.229-.776.393l-.04.025c-.555.338-1.198.73-2.49.868-.333.035-.554.29-.554.55V7c0 .255.226.543.62.65 1.095.3 1.977.997 2.614 1.709.635.71 1.064 1.475 1.238 1.977.243.7.407 1.768.482 2.85.025.362.36.595.667.518l.262-.065c.16-.04.258-.144.288-.255a8.34 8.34 0 0 0-.145-4.726.5.5 0 0 1 .595-.643h.003l.014.004.058.013a9 9 0 0 0 1.036.157c.663.06 1.457.054 2.11-.163.175-.059.45-.301.57-.651.107-.308.087-.67-.266-1.021L12.793 7l.353-.354c.043-.042.105-.14.154-.315.048-.167.075-.37.075-.581s-.027-.414-.075-.581c-.05-.174-.111-.273-.154-.315l-.353-.354.353-.354c.047-.047.109-.176.005-.488a2.2 2.2 0 0 0-.505-.804l-.353-.354.353-.354c.006-.005.041-.05.041-.17a.9.9 0 0 0-.121-.415C12.4 1.272 12.063 1 11.5 1"/>';
    }

    return svg;
}

function addUserReply(parentId, text){
    var icons = document.getElementById('icons-thumbs');
    if(icons){
        icons.style.display = "none";
    }
    const parentDiv = document.getElementById(parentId);
    if (parentDiv) {
        const newDiv = document.createElement("div");
        newDiv.className = "reply user";
        newDiv.innerHTML =  '<span class="name"><div class="name-text">' + username + ':</div></span>\n' +
                            '<span class="text">' + text + '</span>\n';
        parentDiv.appendChild(newDiv);
    }
}


function getTextOnEnter(textAreaId, sendText) {
    const textArea = document.getElementById(textAreaId);
    const sendButton = document.getElementById('sendButton');


    textArea.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault(); // Prevents the newline from being inserted
            setButtonText('Clear');

            var newText = textArea.value;
            if (newText !== "") {
                sendText(textArea, handleText);
            }



            // const text = textArea.value.trim();
            // if (text !== '') {
            //     callback(text, open_ai_model_name);
            // }
            // addUserReply('conversation', text)
            // textArea.value = '';
        }
    });

    sendButton.addEventListener('click', function(event) {
        event.preventDefault();
        setButtonText('Clear');
        var newText = textArea.value;
        if (newText !== "") {
            sendText(textArea, handleText);
        } else {
            clearPromptQAContent();
        }
    });
}
//
function clearPromptQAContent() {
    deleteConversationChildren();
    var prompt_qa_content_element = document.getElementById('prompt-qa-content');
    if (prompt_qa_content_element) {
        var prompt_qa_content_body = document.getElementById('prompt-qa-content-body');
        var parent = prompt_qa_content_element.parentNode;
        parent.style.height = 'auto';
        removeAllChildElements(prompt_qa_content_body);
    }
    context_qa_arr = [];
}

function deleteConversationChildren() {
    var conversationDiv = document.getElementById("conversation");

    if (conversationDiv) {
        var children = conversationDiv.children;

        // Start from index 1 to skip the first child
        for (var i = children.length - 1; i > 0; i--) {
            conversationDiv.removeChild(children[i]);
        }
    }
}



function showLoading() {
    var loadingOverlay = document.getElementById("loadingOverlay");
    loadingOverlay.style.display = "block";
    var chatBtnText = document.getElementById("chatBtnText");
    chatBtnText.style.display = "none";
    loadingStartTime = Date.now();
    updateLoadingTime();
    loadingTimer = setInterval(updateLoadingTime, 1000);
}

function hideLoading() {
    var loadingOverlay = document.getElementById("loadingOverlay");
    loadingOverlay.style.display = "none";
    var chatBtnText = document.getElementById("chatBtnText");
    chatBtnText.style.display = "block";
    clearInterval(loadingTimer);
    loadingStartTime = false;
}

function updateLoadingTime() {
    var loadingTimeElement = document.getElementById("loadingTime");
    var currentTime = Date.now();
    var elapsedSeconds = Math.floor((currentTime - loadingStartTime) / 1000);
    loadingTimeElement.textContent = elapsedSeconds + "";
}

function setButtonText(text) {
    var chatBtnText = document.getElementById("chatBtnText");
    if (chatBtnText) {
        chatBtnText.innerText = text;
    }
}


function setBottomValue(elementSelector, newValue) {
    var element = document.querySelector(elementSelector);

    if (element) {
        element.style.bottom = newValue;
    }
}

function isCheckboxChecked(checkBoxId) {
    var checkbox = document.getElementById(checkBoxId);
    // Check if the checkbox element exists
    if (checkbox) {
        return checkbox.checked; // This will return true if the checkbox is checked, and false otherwise
    } else {
        // If the checkbox does not exist, you might want to handle it accordingly
        console.warn('Checkbox with id "' + checkBoxId + '" not found.');
        return false; // Assuming unchecked if not found
    }
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}




document.addEventListener("DOMContentLoaded", function() {
    const popup = document.getElementById("chat-block");
    const rightBlock = document.getElementById("right-block");
    const openPopupButton = document.getElementById("openPopup");
    const closePopupButton = document.getElementById("closePopup");
    const closeRightBlockButton = document.getElementById("closeRightBlock");
    var myTextArea = document.getElementById("myTextArea");

    var pilgwayCookiesValue = localStorage.getItem('pilgwayCookies');
    console.log("pilgwayCookiesValue", pilgwayCookiesValue);
    if(!pilgwayCookiesValue){
        setBottomValue('.open-popup-btn-container', '120px');
    }

    if (openPopupButton) {
        openPopupButton.addEventListener("click", function () {
            popup.style.display = "block";
            openPopupButton.style.display = "none";
        });
    }

    if (closePopupButton) {
        closePopupButton.addEventListener("click", function () {
            popup.style.display = "none";
            openPopupButton.style.display = "block";
        });
    }

    if (closeRightBlockButton) {
        closeRightBlockButton.addEventListener("click", function () {
            rightBlock.style.display = "none";
            //rightBlock.style.display = "block";
        });
    }

    myTextArea.addEventListener("input", function() {
        var newText = myTextArea.value;
        if (newText !== "") {
            setButtonText('Send');
        } else{
            setButtonText('Clear');
        }
    });



    // Select the SVG elements by their IDs
    var thumbsUp = document.getElementById('thumbs-up');
    var thumbsDown = document.getElementById('thumbs-down');

});


function addReactionEventListener(reactionButton, reaction_type, user_question_id){
    // Add an onclick event listener to the thumbs-up SVG
    reactionButton.addEventListener('click', function() {
        var isActive = reactionButton.classList.contains('active');
        if(!isActive){
            var icons = reactionButton.parentNode.parentNode;
            if(icons) {
                setSvgNotActive(icons);
                //reactionButton.style.opacity = "1.0";
                reactionButton.classList.add('active');
                //const user_question_id = icons.getAttribute('data-userquestionid');
                if(reaction_type === 'Like'){
                    console.log('Thumbs up clicked!', user_question_id);
                    var jsonData = {
                        reaction: 'Like',
                        user_question_id: user_question_id,
                    };
                }
                if(reaction_type === 'Dislike'){
                    console.log('Thumbs down clicked!', user_question_id);
                    var jsonData = {
                        reaction: 'Dislike',
                        user_question_id: user_question_id,
                    };
                }
                showPopUpMessage('Thank you for your feedback!');
                sendJSON(chat_server_url+set_reaction_json_url, jsonData, onReactionResponse);
            }
        }

    });
}

function setSvgNotActive(icons) {
    // Select all SVG elements within the 'icons' div
    var svgElements = icons.querySelectorAll('svg');

    // Loop through each SVG element and set its opacity to 0.5
    svgElements.forEach(function(svg) {
        //svg.style.opacity = opacity;
        svg.classList.remove('active');
    });
}

function onReactionResponse(response) {
    console.log('reaction response', response);
}

function showPopUpMessage() {
    // Get the popup element
    var popup = document.getElementById('popupMessage');

    // Set the popup's content and make it visible
    popup.textContent = 'Thank you for your feedback!';
    popup.style.display = 'block';

    // Hide the popup after 2 seconds
    setTimeout(function() {
        popup.style.display = 'none';
    }, 2000);
}





var loadingStartTime = false;
var loadingTimer;

//var open_ai_model_name = 'text-davinci-003';
//var open_ai_model_name = 'gpt-3.5-turbo-16k';
// var open_ai_model_name = 'gpt-4';
var open_ai_model_name = 'default';

console.log('open_ai_model_name', open_ai_model_name);

getTextOnEnter('myTextArea', sendText);